<template>
  <div class="guides">
    <div class="page-title">Guides</div>
    <BaseLayoutCards>
      <BaseCard>
        <template #header>
          Getting started
        </template>
        <p>
          Thanks for downloading Confetti! If you ever have any questions, feedback or feature requests, please email me at ryanpwaldon@gmail.com.
          Here's a video and some instructions to help you get started.
        </p>
        <BaseVimeo class="video" id="455714751" />
        <p class="title">1. Import a discount</p>
        <p>
          Navigate to the <span class="link" @click="$shopify.redirectToAdminSection('discounts')">discounts page</span> in the Shopify admin. Click
          on a discount to enter edit mode (if you don’t have any discounts, you’ll have to create one first). Click on the
          <em>More actions</em> dropdown, then click the <em>Add to Confetti</em> button.
        </p>
        <p class="title">2. Turn the discount on</p>
        <p>
          To make your discount appear inside the widget, you’ll have to turn it on. Navigate to the imported discount inside Confetti (it should
          appear on the <router-link class="link" to="/widget">widget/discounts page</router-link>) and update its status to <em>On</em>. Now click
          save.
        </p>
        <p class="title">3. Turn the widget on</p>
        <p>
          You’re almost there! The widget is hidden by default. To make the widget appear on your storefront, go to the
          <router-link class="link" to="/widget/settings">widget/settings page</router-link>, update the master switch to <em>On</em>, and click save.
        </p>
        <p>
          The launcher should now appear in the bottom-right corner of your storefront. Click the laucher to open the widget — your discount should
          appear here. Note: the widget will not appear if you have not set any active discounts.
        </p>
        <p class="title">4. You’re all done 🎉</p>
        <p>
          Confetti will automatically sync with any updates to discounts made in the Shopify admin. When your discounts expire, they’ll automatically
          be removed from the widget.
        </p>
      </BaseCard>
    </BaseLayoutCards>
  </div>
</template>

<script>
import BaseLayoutCards from '@/components/BaseLayoutCards/BaseLayoutCards'
import BaseCard from '@/components/BaseCard/BaseCard'
import BaseVimeo from '@/components/BaseVimeo/BaseVimeo'
export default {
  components: {
    BaseLayoutCards,
    BaseCard,
    BaseVimeo
  }
}
</script>

<style lang="scss" scoped>
.guides {
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  grid-gap: var(--spacing-5);
}
.page-title {
  font-size: var(--fs-title);
  font-weight: var(--fw-medium);
}
.video {
  margin: 2rem 0;
}
p {
  margin: 0;
  color: var(--color-gray-3);
  line-height: var(--lh-1);
  &:not(:last-child) {
    margin-bottom: var(--spacing-2);
  }
}
.title {
  color: var(--color-black-1);
  font-weight: var(--fw-medium);
}
.link {
  color: var(--color-blue-1);
  cursor: pointer;
}
</style>
